import { Tooltip, Button } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { PlusOutlined } from '@ant-design/icons'
import styles from './ProjectFormDiscountContent.module.scss'
import { isAddDiscountDisabledSelector, projectFormStateSelector } from 'src/features'
import ProjectFormDiscountModal from './ProjectFormDiscountModal/ProjectFormDiscountModal'

const ProjectFormDiscountContent: React.FC = () => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const isButtonDisabled = useAppSelector(isAddDiscountDisabledSelector)
  const { is_vintage } = useAppSelector(projectFormStateSelector)

  const tooltipLabel = {
    VINTAGE_ERROR: t('Discount.VintageError'),
    NO_VINTAGE_ERROR: t('Discount.NoVintageError')
  }[isButtonDisabled && is_vintage ? 'VINTAGE_ERROR' : isButtonDisabled && !is_vintage && 'NO_VINTAGE_ERROR']

  const modalButton = <Button
    size='large'
    type='dashed'
    icon={<PlusOutlined />}
    disabled={isButtonDisabled}
    className={'float-right radius-100'}
    onClick={() => setIsModalVisible(true)}
  >{t('Discount.AddDiscount')}
  </Button>


  return <div className={styles.content}>
    {/* Modal Button Content */}
    {isButtonDisabled ? <Tooltip title={tooltipLabel} color='red'>
      {modalButton}
    </Tooltip> : modalButton}

    {/* Modal Form */}
    <ProjectFormDiscountModal
      isModalVisible={isModalVisible}
      handleCancel={() => setIsModalVisible(false)}
      reopenModal={() => setIsModalVisible(true)}
    />
  </div>
}

export default ProjectFormDiscountContent
